module.exports = __webpack_public_path__ + "static/media/crypto-economics-lab.1996f275.png";